
// export const logout = ( state ) => {
// }

export const setProductlot = (state, productlot) => {
    state.productlot = productlot
}

export const setProductlotSelectable = (state, productlot) => {
    state.productlotSelectable = productlot
}

export const setProductlotPaginated = (state, productlotPaginatedData) => {
    state.productlotPaginatedData = productlotPaginatedData
}

export const setProductlotDetail = (state, productlot) => {
    state.productlot = productlot
}

export const saveNewProductlot = (state, productlot) => {
    state.productlot.unshift(productlot)
    state.createdData = productlot;
}

export const saveUpdatedProductlot = (state, productlot) => {
    state.productlot.unshift(productlot)
    state.updatedData = productlot;
}

export const setDeleteProductlot = (state, productlot) => {
    state.deletedData = productlot
}

export const setProductlotIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setProductlotIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setProductlotIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setProductlotIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}

export const setProductlotIsFinding = (state, isFindingProductlot) => {
    state.isFindingProductlot = isFindingProductlot
}

export const findProductlot = (state, productlot) => {
    state.findProductlot = productlot;
}

export const setProductlotListByClientIsLoading = (state, isLoading) => {
    state.isLoadingProductlotListByClient = isLoading
}

export const setProductlotListByClientSelectable = (state, productlot) => {
    state.productlotListByClientSelectable = productlot
}

export const findProductlotExist = (state, productlot) => {
    state.findProductlotExist = productlot;
}